import React, { memo } from 'react'
import Flatpickr from 'react-flatpickr'
import PropTypes from 'prop-types'
import uuid from 'uuid/v4'
import { FLATPICKR_DEFAULTS } from 'constants/formElements'
import 'flatpickr/dist/themes/airbnb.css'
import 'scss/5_components/_date-picker.scss'

/**
 * @deprecated
 * Use transfix-ui/components/Calendar instead
 */
export const Calendar = memo(props => {
  const {
    acceptMultiple,
    dataTest,
    dateTimeChangeToState,
    disabled,
    label,
    options,
    placeholder,
    required,
    size,
  } = props

  const handleClose = (dateArr, dateStr) => {
    if (acceptMultiple) {
      if (!dateStr) {
        dateArr = []
      }
      dateTimeChangeToState({ date: dateArr, id: props.id })
    } else {
      dateTimeChangeToState({ date: dateStr, id: props.id })
    }
  }

  const id = props.id || uuid()
  return (
    <>
      {label && (
        <label className={required ? 'required' : ''} htmlFor={id}>
          {label}
        </label>
      )}
      <Flatpickr
        value={props.date}
        id={id}
        data-test={dataTest}
        disabled={disabled}
        placeholder={placeholder}
        className={`input-${size} date-input`}
        options={{
          ...FLATPICKR_DEFAULTS,
          ...options,
          altInput: { 'data-test': dataTest, required },
          altInputClass: `input-${size} date-input`,
          monthSelectorType: 'static',
        }}
        onChange={(dateArr, dateStr) => handleClose(dateArr, dateStr)}
        onClose={(dateArr, dateStr) => handleClose(dateArr, dateStr)}
      />
    </>
  )
})

Calendar.propTypes = {
  options: PropTypes.shape({
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    enableTime: PropTypes.bool,
    noCalendar: PropTypes.bool,
    dateFormat: PropTypes.string,
  }),
  acceptMultiple: PropTypes.bool,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  size: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  dataTest: PropTypes.string,
  dateTimeChangeToState: PropTypes.func.isRequired,
  id: PropTypes.string,
}

Calendar.defaultProps = {
  acceptMultiple: false,
  date: '',
  size: 'medium',
  options: {},
  required: false,
  disabled: false,
  placeholder: 'Select a date',
  label: null,
  dataTest: 'calendar-input',
  id: '',
}

export default Calendar
